module.exports = __webpack_public_path__ + "static/img/leaves.efe0898.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/leaves.svg
// module id = SEet
// module chunks = 1